module.exports = __webpack_public_path__ + "img/kanban-onhold.62d14d14.svg";